<template>
    <path d="M75,20 v60" />
    <path d="M45,50 h30" />
    <path d="M75,50 h10" stroke-width="3"/>
    <path d="M85,50 h30" />
</template>